import { TableRow, TableCell } from "@/components/ui/table";

// Estado vacío útil (Parte F): en vez de una tabla en blanco, explica por qué y ofrece limpiar
// los filtros con un clic.
export function EmptyFiltered({ colSpan, onClear, testId, mensaje = "No hay resultados con estos filtros." }) {
  return (
    <TableRow>
      <TableCell colSpan={colSpan} className="py-10 text-center text-muted-foreground" data-testid={testId}>
        <p>{mensaje}</p>
        {onClear && (
          <button
            type="button"
            onClick={onClear}
            data-testid={`${testId}-clear-btn`}
            className="mt-2 text-sm font-medium text-primary underline"
          >
            Bórralos aquí
          </button>
        )}
      </TableCell>
    </TableRow>
  );
}
